import React, {Component, Fragment} from 'react';
import OrderItem from './OrderItem';
import AddToBoxForm from './AddToBoxForm';
import SplitForm from './SplitForm';
import classes from './UnboxedItem.css';

export default class UnboxedItem extends Component {
    render() {
        return (
            <tr className={classes.unboxedItem}>
                <td className={classes.unboxedItem__info}>
                    <OrderItem item={this.props.item.item} />
                </td>
                <td className="nowrap">
                    × {this.props.item.quantity}
                </td>
                <td className="nowrap">
                    {this.state.form === 'addToBox' && (
                        <AddToBoxForm
                            item={this.props.item}
                            boxes={this.props.boxes}
                            onAddToBox={(box, quantity) => {
                                this.props.onAddToBox(box, quantity)
                                this.setForm(null);
                            }}
                            onAddBox={(quantity) => {
                                this.props.onAddBox(quantity)
                                this.setForm(null);
                            }}
                            onCancel={() => this.setForm(null)}
                        />
                    )}
                    {this.state.form === 'split' && (
                        <SplitForm
                            item={this.props.item}
                            onSplit={(quantity, countParts) => {
                                this.props.onSplit(quantity, countParts)
                                this.setForm(null);
                            }}
                            onCancel={() => this.setForm(null)}
                        />
                    )}
                    {this.state.form === null && this.props.item.quantity > 0 && (window.ui_version == 2) && (
                        <div class="inlinebox">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setForm('addToBox');
                                }}
                                className="custom-mr-16"
                            >
                                <i className="fas fa-long-arrow-alt-right custom-mr-8" />
                                Добавить в коробку
                            </a>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.setForm('split');
                                }}
                            >
                                <i className="fas fa-code-branch custom-mr-8" />
                                Разделить
                            </a>
                        </div>
                    )}

                    {this.state.form === null && this.props.item.quantity > 0 && (window.ui_version != 2) && (
                        <ul className="menu-h">
                            <li>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setForm('addToBox');
                                    }}
                                >
                                    <i className="icon16 move" />
                                    Добавить в коробку
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setForm('split');
                                    }}
                                >
                                    <i className="icon16 split" />
                                    Разделить
                                </a>
                            </li>
                        </ul>
                    )}
                </td>
            </tr>
        );
    }

    constructor(props) {
        super(props);
        this.state = {
            form: null
        };
    }

    setForm(form) {
        this.setState({
            form: form
        });
    }
}